import WarningAlert from "../../../components/general/WarningAlert";
import { getRebrandedTranslation } from "../../../utils/i18nUtils";
import { isDeviceOnExperimentalMode } from "../../../utils/userAgentUtils";
import React from "react";
import { EmbeddedStreamer } from "../../../components/browser/appStream/EmbeddedStreamer";
import { useTranslation } from "react-i18next";
import { useSessionDataStore } from "../../../hooks/useSessionDataStore";
import { useNavigateStore } from "../../../stepFlowHooks/useNavigateStore";

/**
 * TODO [LOWA-30534] Will move some logic from EmbeddedStreamer (e.g. loader, toolbar, ...)
 */
export const StreamingStep = () => {
    const { t } = useTranslation();
    const streamingUrl = useSessionDataStore((store) => store.streamingUrl);
    const navigateToSignInStep = useNavigateStore(
        (store) => store.navigateToSignInStep
    );
    const navigateToPostStreamingStep = useNavigateStore(
        (store) => store.navigateToPostStreamingStep
    );

    return (
        <>
            <WarningAlert
                title={getRebrandedTranslation(
                    "experimentalMode.alert.title",
                    t
                )}
                message={getRebrandedTranslation(
                    "experimentalMode.alert.message",
                    t
                )}
                render={isDeviceOnExperimentalMode()}
            />
            <EmbeddedStreamer
                endpoint={streamingUrl}
                onRedirectToLogin={navigateToSignInStep}
                onSignOut={navigateToPostStreamingStep}
            />
        </>
    );
};
